export default "__VITE_ASSET__CsTPPNCs__"